import { App } from 'vue'
import AccountDeleteForm from './AccountDeleteForm.vue'
import AuthForm from './AuthForm.vue'
import PasswordReset from './PasswordReset.vue'
import PasswordChange from './PasswordChange.vue'

const register = (app: App<Element>): void => {
  app
  .component('AuthForm', AuthForm)
  .component('PasswordReset', PasswordReset)
  .component('AccountDeleteForm', AccountDeleteForm)
  // .component('PasswordChange', PasswordChange)
}

export default {
  register,
}
